import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { renderRoutes } from 'react-router-config'

import { awardUnits as awardUnitsLayout } from 'constants/layout'
import {
  apiOrganizations,
  apiCodeLists,
  apiTasksOverview,
  apiConfiguration
} from 'helpers/decorators/api'
import { CONFIGURATION_KEYS } from 'constants/enums'

// put STAFF_COUNT to enums
const enhance = compose(
  apiCodeLists([
    'organizationTypes',
    'organizationStates',
    'organizationModes'
  ]),
  apiTasksOverview({ overview: true, forOrganisation: true }),
  apiOrganizations({
    detail: true,
    params: 'STAFF_COUNT'
  }),
  apiConfiguration({
    getValues: [
      CONFIGURATION_KEYS.onlineMasterCardPayment.id,
      CONFIGURATION_KEYS.manageAssessors.id,
      CONFIGURATION_KEYS.offlineAu.id
    ],
    inOrganizationDetail: true
  })
)

class AwardUnit extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    tabs: PropTypes.object.isRequired,
    tasks: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    organizations: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired
  }

  static defaultProps = {
    params: {}
  }

  render() {
    const {
      tabs,
      children,
      organizations,
      codeLists,
      route,
      tasks,
      params
    } = this.props

    const extraProps = {
      organizations,
      organisationId: params.id,
      codeLists,
      ...this.props
    }

    return (
      <div>
        {tabs && React.cloneElement(tabs, {
          links: awardUnitsLayout.tabs({ isIac: route.isIac }),
          overview: tasks.overview,
          organisationId: params.id
        })}
        {children
          ? React.cloneElement(children, extraProps)
          : renderRoutes(route.routes, extraProps)
        }
      </div>
    )
  }
}

export default enhance(AwardUnit)
